// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingResult_base--1uBX2","greeting":"LandingResult_greeting--1UyjL","message":"LandingResult_message--2aWm5","clan":"LandingResult_clan--3xWPY","base__waiting":"LandingResult_base__waiting--EHbZl","baseWaiting":"LandingResult_base__waiting--EHbZl","awardContainer":"LandingResult_awardContainer--1XLA_","awardImage":"LandingResult_awardImage--24tYC","awardMessage":"LandingResult_awardMessage--35Wdq","warningIcon":"LandingResult_warningIcon--12x6C","info":"LandingResult_info--3KaMU","button":"LandingResult_button--1yOB4"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/LandingResult.scss
// module id = 2289
// module chunks = 11